import styled from 'styled-components';

export const AvatarBlock = styled.div`
  flex: 0 0 auto;
  padding: 0 0 10px;
  display: flex;
  gap: 20px;
  align-items: flex-start;
`;
